<template>
  <div class="team-detail-count-down">
    仅差 <span class="strong primary remain-member">{{ remainMember }}</span> 人 ，即可成团
    <div class="count-down">
      剩余
      <span class="strong">{{ timerData.hours }}</span> 时
      <span class="strong">{{ timerData.minutes }}</span> 分
      <span class="strong">{{ timerData.seconds }}</span> 秒
    </div>
  </div>
</template>

<script>
  import CountDown from '@/utils/count-down';

  export default {
    name: 'TeamDetailCountDown',
    data() {
      return {
        timerData: {
          days: '00',
          hours: '00',
          minutes: '00',
          seconds: '00',
        },
      };
    },
    props: {
      teamSize: {
        type: Number,
        required: true,
      },
      memberLength: {
        type: Number,
        required: true,
      },
      currentTime: {
        type: Number,
        required: true,
      },
      expiredTime: {
        type: Number,
        required: true,
      },
    },
    computed: {
      remainMember() {
        return this.teamSize - this.memberLength;
      },
    },
    methods: {
      initCountDown() {
        new CountDown({
          startTime: this.currentTime,
          endTime: this.expiredTime,
          render: (data) => {
            this.timerData = data;
          },
        });
      },
    },
    created() {
      this.initCountDown();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .team-detail-count-down {
    text-align: center;
    color: @color-text-base;
    margin-top: @size-small;
    margin-bottom: @size-medium;
  }

  .count-down {
    margin-top: @size-small;
  }

  .strong {
    font-weight: @font-weight-primary;
    font-size: @font-size-medium;
  }

  .primary {
    color: @color-highlight;
    font-weight: @font-weight-primary;
  }

  .remain-member {
    font-size: @font-size-medium;
  }
</style>
